var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZonemenusvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.25 46H6C4.67392 46 3.40215 45.4732 2.46447 44.5355C1.52678 43.5979 1 42.3261 1 41V6C1 4.67392 1.52678 3.40215 2.46447 2.46447C3.40215 1.52678 4.67392 1 6 1H41C42.3261 1 43.5979 1.52678 44.5355 2.46447C45.4732 3.40215 46 4.67392 46 6V21M1 18.5H46M18.5 1V46",
    stroke: "#6ACDFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.75 43.75C34.75 43.75 41.7935 37.4891 41.7935 32.7935C41.7935 28.9035 38.64 25.75 34.75 25.75C30.86 25.75 27.7065 28.9035 27.7065 32.7935C27.7065 37.4891 34.75 43.75 34.75 43.75Z",
    stroke: "#6ACDFF",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0003 32.5001C37.0003 33.7428 35.9929 34.7501 34.7503 34.7501C33.5077 34.7501 32.5003 33.7428 32.5003 32.5001C32.5003 31.2575 33.5077 30.2501 34.7503 30.2501C35.9929 30.2501 37.0003 31.2575 37.0003 32.5001Z",
    stroke: "#6ACDFF",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZonemenusvg);
export default __webpack_public_path__ + "static/media/zonemenusvg.59ec72fb4cb3f2ccf094d755876ee787.svg";
export { ForwardRef as ReactComponent };